import * as actions from "../actions/actions";
import { connect } from "react-redux";
import { hashHistory } from "react-router";
import React from "react";

import Icon from "./nounproject-ui-icon";
import PluginToolbar from "./plugin-toolbar";
import PluginFooter from "./plugin-footer";

class PluginAbout extends React.Component {
    closeAbout(e) {
        e.preventDefault();
        hashHistory.push("search");
    }

    render() {
        let header, imgName, content, bullets;

        switch (this.props.host) {
            case "office":
                header =
                    "A million high-quality icons to choose from, perfect for presentations.";
                imgName = require("../../plugins/office/office365_video.gif");
                content =
                    "Choose from a huge collection of high-quality icons, quickly add color and edit image size. Add some fun to your presentation decks and simplify information overload with simple to understand, beautiful symbols. Noun Project is the best known collection of over 1 million high-quality symbols, built by creatives from around the world. Get free access to 100 of our most frequently used pictograms (no need to create an account), or unlock the entire collection for just $39.99 per year. Icons are a great way to visually illustrate any idea. Noun Project has the most diverse collection ever - from Beyoncé to Venn diagrams, we got you covered.";
                bullets = (
                    <ul
                        className="bullet-list"
                        style={{
                            padding: "24px"
                        }}
                    >
                        <li>
                            {
                                "No account required for free use, no trial periods to deal with"
                            }
                        </li>
                        <li>
                            {
                                "Easily search and insert icons right from your task pane, stay in your workflow"
                            }
                        </li>
                        <li>
                            {
                                "Add icons to your PowerPoint or Word with just one click"
                            }
                        </li>
                        <li>
                            {
                                "Add-in remembers your last used color and size for speed and consistency"
                            }
                        </li>
                        <li>
                            {
                                "Connect your existing Noun Project account, or start a new one (no account needed for free users)"
                            }
                        </li>
                        <li>
                            {"Cave paintings < ClipArt < Noun Project"}
                        </li>
                    </ul>
                );
                break;
            case "adobe":
                header = "A million high-quality icons to choose from.";
                imgName = require("../../plugins/adobe/adobe_video_saturated.gif");
                content =
                    "Choose from a huge collection of high-quality icons, quickly add color and edit image size. Noun Project is the best known collection of over 1 million high-quality symbols, built by creatives from around the world. Get free access to 100 of our most frequently used pictograms (no need to create an account), or unlock the entire collection for just $39.99 per year. Icons are a great way to visually illustrate any idea. Noun Project has the most diverse collection ever - from Beyoncé to Venn diagrams, we got you covered.";
                bullets = (
                    <ul
                        className="bullet-list"
                        style={{
                            padding: "24px"
                        }}
                    >
                        <li>
                            {
                                "No account required for free use, no trial periods to deal with"
                            }
                        </li>
                        <li>
                            {
                                "Easily search and insert icons right from the panel, stay in your workflow"
                            }
                        </li>
                        <li>
                            {
                                "Add icons to Illustrator, Photoshop, or InDesign with just one click"
                            }
                        </li>
                        <li>
                            {
                                "Add-on remembers your last used color and size for speed and consistency"
                            }
                        </li>
                        <li>
                            {
                                "Connect your existing Noun Project account, or start a new one (no account needed for free users)"
                            }
                        </li>
                        <li>
                            {"Cave paintings < ClipArt < Noun Project"}
                        </li>
                    </ul>
                );
                break;
            case "gsuite":
                header =
                    "A million high-quality icons to choose from, perfect for presentations.";
                imgName = require("../../plugins/gsuite/google_video.gif");
                content = (
                    <div>
                        <p>
                            Get access to over 1 million high-quality icons from
                            Noun Project. For icons from Beyoncé to Venn
                            diagrams, we got you covered.
                        </p>
                        <p>
                            Icons are a great way to visually illustrate any
                            idea. With this add-on, you can quickly find the
                            icon you need, change its color and size, and insert
                            it right into your slide or doc with just one click,
                            all without leaving your workflow. Choose from a
                            huge, ever-growing collection of high-quality
                            symbols, built by creatives from around the world.
                        </p>
                        <p>
                            Perfect for teachers, marketers, sales teams, and
                            anyone needing to quickly create beautiful,
                            insightful content.{" "}
                        </p>
                        <p>
                            The add-on is free to use (no account required) with
                            access to 100 of our most frequently used
                            pictograms. Or unlock the entire collection of over
                            1 million royalty-free icons, as well as full access
                            to all Pro features, for $39.99 per year. Special
                            discount is available for the Education Community.
                            All proceeds are shared directly with our creative
                            community.
                        </p>
                    </div>
                );
                bullets = (
                    <ul
                        className="bullet-list"
                        style={{
                            padding: "24px"
                        }}
                    >
                        <li>
                            {
                                "No account required for free use, no trial periods to deal with"
                            }
                        </li>
                        <li>
                            {
                                "Easily search and insert icons right from your task pane, stay in your workflow"
                            }
                        </li>
                        <li>
                            {
                                "Add icons to your Docs or Slides with just one click"
                            }
                        </li>
                        <li>
                            {
                                "Add-on remembers your last used color and size for speed and consistency"
                            }
                        </li>
                        <li>
                            {
                                "Connect your existing Noun Project account, or start a new one (no account needed for free users)"
                            }
                        </li>
                        <li>
                            {
                                "The most diverse collection of icons for everything"
                            }
                        </li>
                        <li>
                            {"Cave paintings < ClipArt < Noun Project"}
                        </li>
                    </ul>
                );
                break;
        }

        return (
            <span>
                <div className="quick-nav">
                    <PluginToolbar />
                </div>
                <div
                    className="plugin-about"
                    style={{
                        background: "#000000",
                        color: "#FFFFFF",
                        padding: "50px 16px 100px",
                        minHeight: "100%"
                    }}
                >
                    <div className="plugin-menu-header">
                        <a
                            href="#"
                            className="menu-close"
                            onClick={this.closeAbout.bind(this)}
                            title="Cancel"
                        >
                            <Icon
                                iconId="close.svg"
                                className="icon-14"
                                color="#FFFFFF"
                            />
                        </a>
                    </div>
                    <div
                        style={{
                            maxWidth: "600px",
                            margin: "auto"
                        }}
                    >
                        <span className="ui_logo" />
                        <h1 className="font-large margin-b-s margin-t-xxl ">
                            Icons for everything
                        </h1>
                        <p>
                            {header}
                        </p>
                        <img src={imgName} width="100%" />
                        <div>
                            {content}
                        </div>
                        <style>{`
                            .bullet-list li{
                                padding-bottom: 8px;
                                list-style: disc;
                            }
                        `}</style>

                        {bullets}

                        <p className="weight-medium">
                            Learn more at{" "}
                            <a
                                href="https://thenounproject.com"
                                onClick={window.handleLink.bind(this)}
                                target="_blank"
                                style={{
                                    color: "#FFFFFF",
                                    textDecoration: "underline"
                                }}
                            >
                                nounproject.com
                            </a>
                        </p>

                        <ul>
                            <li>
                                <a
                                    target="_blank"
                                    href="/legal/#!terms-of-use"
                                    onClick={window.handleLink.bind(this)}
                                    style={{
                                        color: "#FFFFFF",
                                        textDecoration: "underline"
                                    }}
                                >
                                    Terms of service
                                </a>
                            </li>
                            <li>
                                <a
                                    target="_blank"
                                    href="/legal/#!privacy-policy"
                                    onClick={window.handleLink.bind(this)}
                                    style={{
                                        color: "#FFFFFF",
                                        textDecoration: "underline"
                                    }}
                                >
                                    Privacy Policy
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <PluginFooter />
            </span>
        );
    }
}

function mapStateToProps(state, ownProps) {
    let host = state.plugin.host;

    return { host };
}

module.exports = connect(mapStateToProps, {})(PluginAbout);
